"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const ParentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ParentWrapper",
  class: "pl-p3vx06y"
});
const IconSpan = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconSpan",
  class: "pl-ictfp0l"
});
const ItemParagraph = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ItemParagraph",
  class: "pl-i19evwur"
});
const SeparatorDot = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "SeparatorDot",
  class: "pl-s1pdvlyj"
});

/**
 * TickerItem Component.
 *
 * @param {Object} props React props
 * @param {string} text Ticker item text
 * @param {string} icon Ticker item icon
 * @param {number} index Ticker item index
 * @returns {React.ReactElement} TickerItem Component
 * @public
 */

function TickerItem({
  text,
  icon,
  index
}) {
  const IconType = /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  });
  return /*#__PURE__*/_react.default.createElement(ParentWrapper, {
    "data-cy": "ticker-item"
  }, /*#__PURE__*/_react.default.createElement(SeparatorDot, null), index % 3 === 0 ? /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    className: "list-headline",
    size: 4,
    text: text
  }) : /*#__PURE__*/_react.default.createElement(ItemParagraph, null, icon && /*#__PURE__*/_react.default.createElement(IconSpan, null, IconType), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    className: "list-title",
    size: 1,
    text: text
  })));
}
var _default = exports.default = TickerItem;
TickerItem.propTypes = {
  text: _propTypes.default.string.isRequired,
  icon: _propTypes.default.string,
  index: _propTypes.default.number
};